import React, { useEffect, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import quill from "quill";

window.Quill = quill;

Quill.register("modules/imageResize", ImageResize);

const Block = Quill.import("blots/block");

class CustomBackground extends Block {
  static create(value) {
    const node = super.create();
    node.style.backgroundColor = value;
    return node;
  }
 
  static formats(node) {
    return node.style.backgroundColor;
  }
 
  format(name, value) {
    if (name === "background") {
      this.domNode.style.backgroundColor = value;
    } else {
      super.format(name, value);
    }
  }
}
CustomBackground.blotName = "background";
CustomBackground.tagName = "DIV";
Quill.register(CustomBackground);

const QuestionEditor = ({ data, setQuestion, setIsDataSaved }) => {
  const [editorContent, setEditorContent] = useState("");

  useEffect(() => {
    if (data) {
      setEditorContent(data);
    } else {
      setEditorContent("");
    }
  }, []);

  useEffect(() => {
    setQuestion((question) => {
      return { ...question, text: editorContent };
    });
  }, [editorContent, setQuestion]);

  const handleChange = (html) => {
    setIsDataSaved(false);
    setEditorContent(html);
  };

  const modules = {
    toolbar: [
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline"],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      [{ color: [] }, { background: [] }],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
  };

  const formats = [
    "header",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "align",
    "color",
    "background", // Include block-level background format
  ];

  return (
    <div className="border-2 border-gray-300 mb-2 rounded-lg p-3 min-h-[150px] overflow-y-auto">
      <ReactQuill
        onChange={handleChange}
        value={editorContent}
        modules={modules}
        formats={formats}
        bounds="#root"
        placeholder={"Enter your question"}
      />
    </div>
  );
};

export default QuestionEditor;
